import React, { memo, useEffect } from "react";
import { Spin, Icon, Avatar } from "antd";
import { FormLabel } from "../Components/FormLabel";
import { useData } from "../hooks/useData";
import { CommonComponentsProps } from "../../../types/common";
import { print_when_component_is_rendered } from "../../../../utils/develop";
import { useInputHandle } from "../hooks/InputHandle";
import { Group } from "../Components/Group";
import { compareProps, getFullPathRow } from "../handle/inputHandle";
import { Session, Utilitaries } from "../../../../business";
import { mapLoad } from "../../../utils/loadMap";
import { baseUrl } from "../../../../constants/enviroment";

interface ComponentsPropertiesProps extends CommonComponentsProps {}

const _QADataDisplay: React.FC<ComponentsPropertiesProps> = ({
    // label, itemData, numbersOfColumnsToRender ,
    componentsProperties,
    renderContext,
    formState,
    handleOnInputChangeValue,
    formInputDependenceState,
    inputCalcTrigger,
    tableRow,
    rootElementAttribute,
}) => {
    print_when_component_is_rendered(componentsProperties);

    const value =
        renderContext === "column" ? tableRow?.row_data?.[componentsProperties.key] : componentsProperties.value;

    const displayValue = () => {
        return Utilitaries.isEmpty(value) ? "" : value;
    };

    const { data, status: dataStatus } = useData({
        endPoint: "execQuery.php",
        componentsProperties,
        state: formState,
        rootElementAttribute,
    });

    useEffect(() => {
        if (data && dataStatus !== "IDLE" && componentsProperties.data_query) {
            handleOnInputChangeValue({
                value: data?.[0]?.[componentsProperties.key_list || componentsProperties.key],
                componentsProperties,
                row_key: tableRow?.row_key,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const fullPathRow = getFullPathRow(componentsProperties, tableRow?.row_key);
    const full_path = tableRow?.row_key ? fullPathRow : componentsProperties?.full_path;

    const {
        // data: whenValueChangeData,
        status: whenValueChangeStatus,
        componentValue,
        hasUpdatedValue,
        required,
        visible,
        relevant,
        calculated,
    } = useInputHandle({
        componentProperties: componentsProperties,
        when_value_changed_dependence: formInputDependenceState?.[full_path || ""],
        calcTrigger: inputCalcTrigger?.[componentsProperties?.full_path || ""],
        calcRowTrigger: inputCalcTrigger?.[fullPathRow],
        formState,
        rowTable: tableRow,
    });

    useEffect(() => {
        if (hasUpdatedValue > 0 && whenValueChangeStatus !== "IDLE") {
            handleOnInputChangeValue({
                value: componentValue,
                componentsProperties,
                row_key: tableRow?.row_key,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasUpdatedValue]);

    useEffect(() => {
        if (
            componentsProperties.calculate &&
            (!Utilitaries.isEmpty(inputCalcTrigger?.[componentsProperties?.full_path || ""]) ||
                !Utilitaries.isEmpty(inputCalcTrigger?.[fullPathRow]) ||
                componentsProperties.persist === "nao")
        ) {
            handleOnInputChangeValue({
                value: calculated,
                componentsProperties,
                row_key: tableRow?.row_key,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [calculated]);

    if (!visible || !relevant) {
        return null;
    }

    const antIcon = <Icon type="loading" spin />;
    // style={{ fontSize: 24 }}
    // line-height: inherit; for item

    // const customStyle: any = { margin: 0 };
    const customStyle: any = { margin: 0, whiteSpace: "pre-wrap" };

    const isFullScreen = Utilitaries.toString(componentsProperties?.style).includes("qa_col_24");
    if (!isFullScreen && renderContext !== "column") {
        customStyle.maxWidth = "300px";
    }

    const isBold = Utilitaries.toString(componentsProperties?.style).includes("negrito");
    if (isBold) {
        customStyle.fontWeight = "bold";
    }
    if (renderContext === "column") {
        if (componentsProperties.style?.includes("badge") || componentsProperties.style?.includes("avatar")) {
            const color = tableRow?.row_data?.[componentsProperties.key + "_color"] || "#87d068";
            const image = Utilitaries.toString(tableRow?.row_data?.["imagem"]);
            const imageURL = `${baseUrl}/Gestor/geredocumentos.php?accao=ficheiro&ficheiro=${image}&token=Bearer ${Session.getToken()}`;

            return (
                <pre style={{ ...customStyle }}>
                    {displayValue() !== "" && displayValue() !== "-" && !image && (
                        <Avatar style={{ backgroundColor: color }} size={16} />
                    )}
                    {displayValue() !== "" && displayValue() !== "-" && image && (
                        <img src={imageURL} alt="avatar" style={{ height: 32, width: 25 }} />
                    )}{" "}
                    {displayValue()}{" "}
                    {mapLoad([dataStatus, whenValueChangeStatus]) && <Spin indicator={antIcon} size="small" />}
                </pre>
            );
        }

        return (
            <pre style={{ ...customStyle }}>
                {displayValue()}{" "}
                {mapLoad([dataStatus, whenValueChangeStatus]) && <Spin indicator={antIcon} size="small" />}
            </pre>
        );
    }

    return (
        <Group componentsProperties={componentsProperties} renderContext={renderContext}>
            <FormLabel componentsProperties={componentsProperties} required={required} renderContext={renderContext}>
                <pre style={{ ...customStyle }}>
                    {displayValue()}{" "}
                    {mapLoad([dataStatus, whenValueChangeStatus]) && <Spin indicator={antIcon} size="small" />}
                </pre>
            </FormLabel>
        </Group>
    );
};

export const QADataDisplay = memo(_QADataDisplay, (prev, next) => compareProps<ComponentsPropertiesProps>(prev, next));
